import { v1 } from './common/clients';

export default {
  placeOrder: (placeUri, body) => v1.post(`/places/${placeUri}/orders/ui`, body),
};
